// Definición declarativa de las extensiones de perfil. Solo pide lo que NO está en el Perfil Base.
const L = (es, en) => ({ es, en });

export const ZONES = ["Baleares", "Costa Brava", "Costa Blanca", "Costa del Sol", "Cantábrico", "Galicia", "Canarias", "Otra"];
export const EXPERIENCE = [
  { v: "none", l: L("Sin experiencia", "No experience") },
  { v: "basic", l: L("Básico", "Basic") },
  { v: "intermediate", l: L("Intermedio", "Intermediate") },
  { v: "advanced", l: L("Avanzado", "Advanced") },
];
export const LICENSES = ["Ninguna", "Licencia de navegación", "PNB", "PER", "Patrón de Yate", "Capitán de Yate", "Otra"];
const BOAT_TYPES = [
  { v: "sailboat", l: L("Velero", "Sailboat") },
  { v: "motor", l: L("Motor", "Motor") },
  { v: "catamaran", l: L("Catamarán", "Catamaran") },
];
const SEASONS = [
  { v: "spring", l: L("Primavera (abr–jun)", "Spring (Apr–Jun)") },
  { v: "july", l: L("Julio", "July") },
  { v: "august", l: L("Agosto", "August") },
  { v: "september", l: L("Septiembre", "September") },
  { v: "autumn", l: L("Otoño (oct–nov)", "Autumn (Oct–Nov)") },
  { v: "winter", l: L("Invierno", "Winter") },
];
const yn = [{ v: "yes", l: L("Sí", "Yes") }, { v: "no", l: L("No", "No") }];

export const EXTENSIONS = {
  buyer: {
    title: L("Comprador", "Buyer"),
    desc: L("Buscar o comprar una participación o un barco completo.", "Find or buy a share or a whole boat."),
    submitLabel: L("Activar perfil comprador", "Activate buyer profile"),
    sections: [
      { title: L("Patrón de uso", "Usage pattern"), fields: [
        { k: "days_per_year", t: "number", l: L("Días de navegación previstos al año", "Sailing days per year"), min: 1, max: 120, req: true },
        { k: "seasons", t: "chips", l: L("Franjas preferentes", "Preferred periods"), opts: SEASONS, req: true },
        { k: "flexibility", t: "radio", l: L("Flexibilidad de fechas", "Date flexibility"), opts: [
          { v: "high", l: L("Alta — me adapto", "High") }, { v: "medium", l: L("Media", "Medium") }, { v: "low", l: L("Baja — fechas fijas", "Low — fixed dates") }] },
      ]},
      { title: L("Presupuesto", "Budget"), fields: [
        { k: "budget_min", t: "number", l: L("Inversión mínima (€)", "Min investment (€)"), req: true },
        { k: "budget_max", t: "number", l: L("Inversión máxima (€)", "Max investment (€)"), req: true },
        { k: "bigger_share", t: "radio", l: L("¿Pagarías por una participación mayor (50%) o menor (12,5%)?", "Would you pay for a bigger/smaller share?"), opts: [
          { v: "bigger", l: L("Mayor", "Bigger") }, { v: "smaller", l: L("Menor", "Smaller") }, { v: "standard", l: L("Solo 25%", "Only 25%") }, { v: "any", l: L("Indiferente", "Any") }] },
      ]},
      { title: L("Embarcación", "Boat"), fields: [
        { k: "boat_types", t: "chips", l: L("Tipo de embarcación", "Boat type"), opts: BOAT_TYPES, req: true },
        { k: "length_min", t: "number", l: L("Eslora mínima (m)", "Min length (m)") },
        { k: "length_max", t: "number", l: L("Eslora máxima (m)", "Max length (m)") },
      ]},
      { title: L("Modo de acceso", "Access mode"), fields: [
        { k: "access_mode", t: "radio", l: L("¿Cómo quieres acceder al barco?", "How do you want to access the boat?"), req: true, opts: [
          { v: "coownership", l: L("Copropiedad (participación real)", "Co-ownership") },
          { v: "subscription", l: L("Suscripción", "Subscription") },
          { v: "rental", l: L("Alquiler puntual", "Occasional rental") },
          { v: "full", l: L("Compra completa", "Full purchase") }] },
        { k: "group_mode", t: "radio", l: L("Copropietarios", "Co-owners"), showIf: { access_mode: "coownership" }, opts: [
          { v: "find", l: L("Buscar compatibles con Bevela", "Find compatible people") }, { v: "have_group", l: L("Ya tengo mi grupo", "I already have my group") }] },
        { k: "group_emails", t: "emails", l: L("Emails de tu grupo (les enviaremos invitación)", "Your group's emails"), showIf: { group_mode: "have_group" } },
      ]},
    ],
  },
  seller: {
    title: L("Vendedor", "Seller"),
    desc: L("Publicar la venta de una participación o de un barco completo.", "List a share or a whole boat for sale."),
    review: true,
    submitLabel: L("Enviar a verificación", "Submit for verification"),
    sections: [
      { title: L("Datos fiscales (KYC de venta)", "Tax details (KYC)"), fields: [
        { k: "tax_id", t: "text", l: L("NIF / CIF", "Tax ID"), req: true },
        { k: "tax_address", t: "text", l: L("Dirección fiscal", "Tax address"), req: true },
      ]},
      { title: L("El barco", "The boat"), fields: [
        { k: "boat_id", t: "boat", l: L("Elige una de tus embarcaciones (o regístrala primero)", "Pick one of your boats (or register it first)"), req: true },
        { k: "maintenance_state", t: "radio", l: L("Estado de mantenimiento", "Maintenance state"), opts: [
          { v: "excellent", l: L("Excelente", "Excellent") }, { v: "good", l: L("Bueno", "Good") }, { v: "needs_work", l: L("Necesita trabajo", "Needs work") }] },
        { k: "doc_itb", t: "doc", l: L("ITB / certificado de navegabilidad", "Seaworthiness certificate") },
        { k: "doc_insurance", t: "doc", l: L("Póliza de seguro", "Insurance policy") },
        { k: "doc_ownership", t: "doc", l: L("Documento de titularidad (obligatorio)", "Proof of ownership (required)"), req: true },
      ]},
      { title: L("La venta", "The sale"), fields: [
        { k: "sale_type", t: "radio", l: L("Tipo de venta", "Sale type"), req: true, opts: [
          { v: "share", l: L("Participación · busco copropietarios", "Share · looking for co-owners") },
          { v: "full", l: L("Venta completa", "Full sale") },
          { v: "managed", l: L("Venta con Bevela gestionando la copropiedad resultante", "Sale with Bevela managing the resulting co-ownership") }] },
        { k: "price", t: "number", l: L("Precio deseado (€)", "Asking price (€)"), req: true },
        { k: "price_floor", t: "number", l: L("Mínimo negociable (€)", "Negotiable floor (€)") },
        { k: "post_sale", t: "radio", l: L("Después de la venta", "After the sale"), opts: [
          { v: "keep_share", l: L("Quedarme como copropietario de una fracción", "Keep a fraction") }, { v: "exit", l: L("Salir completamente", "Exit completely") }] },
      ]},
    ],
  },
  owner: {
    title: L("Propietario · gestión", "Owner · management"),
    desc: L("Ya tengo un barco y quiero que Bevela lo gestione (Vía B).", "I already own a boat and want Bevela to manage it."),
    review: true,
    submitLabel: L("Enviar a verificación de titularidad", "Submit for ownership verification"),
    sections: [
      { title: L("Tu barco", "Your boat"), fields: [
        { k: "boat_id", t: "boat", l: L("Elige tu embarcación (o regístrala primero)", "Pick your boat (or register it first)"), req: true },
        { k: "doc_ownership", t: "doc", l: L("Documento de titularidad (obligatorio)", "Proof of ownership (required)"), req: true },
      ]},
      { title: L("Copropietarios existentes", "Existing co-owners"), fields: [
        { k: "coowner_emails", t: "emails", l: L("Emails de los copropietarios que deben tener acceso al panel", "Co-owners who need dashboard access") },
      ]},
      { title: L("Servicios que quieres contratar", "Services you want"), fields: [
        { k: "services", t: "chips", l: L("Elige todos o solo algunos", "Pick all or some"), req: true, opts: [
          { v: "maintenance", l: L("Mantenimiento", "Maintenance") }, { v: "cleaning", l: L("Limpieza", "Cleaning") },
          { v: "insurance", l: L("Seguros", "Insurance") }, { v: "documents", l: L("Documentación", "Paperwork") },
          { v: "calendar", l: L("Gestión de calendario", "Calendar management") }, { v: "rental", l: L("Alquiler de días no usados", "Rent unused days") }] },
      ]},
    ],
  },
  renter: {
    title: L("Alquiler y salidas", "Rental & trips"),
    desc: L("Alquilar un barco, apuntarme a salidas compartidas o poner el mío en alquiler.", "Rent a boat, join shared trips or list mine."),
    submitLabel: L("Activar perfil alquilador", "Activate rental profile"),
    sections: [
      { title: L("¿Qué quieres hacer?", "What do you want?"), fields: [
        { k: "role_user", t: "toggle", l: L("Quiero alquilar barcos o apuntarme a salidas compartidas", "I want to rent boats or join shared trips") },
        { k: "role_owner", t: "toggle", l: L("Quiero poner mi barco en alquiler", "I want to list my boat for rent") },
      ]},
      { title: L("Como usuario", "As a user"), showIf: { role_user: true }, fields: [
        { k: "companions", t: "number", l: L("Número habitual de acompañantes", "Usual number of companions"), min: 0, max: 30 },
        { k: "trip_type", t: "chips", l: L("Tipo de salida", "Trip type"), opts: [{ v: "private", l: L("Privada", "Private") }, { v: "shared", l: L("Compartida", "Shared") }] },
        { k: "interests", t: "chips", l: L("Intereses", "Interests"), showIf: { trip_type: "shared" }, opts: [
          { v: "fishing", l: L("Pesca", "Fishing") }, { v: "diving", l: L("Buceo", "Diving") }, { v: "party", l: L("Fiesta", "Party") }, { v: "relax", l: L("Relax", "Relax") }] },
      ]},
      { title: L("Como propietario", "As an owner"), showIf: { role_owner: true }, fields: [
        { k: "boat_id", t: "boat", l: L("Embarcación a alquilar", "Boat to rent"), req: true },
        { k: "capacity", t: "number", l: L("Capacidad (personas)", "Capacity"), req: true },
        { k: "equipment", t: "text", l: L("Equipamiento destacado", "Key equipment") },
        { k: "skipper", t: "radio", l: L("Patrón", "Skipper"), opts: [{ v: "with", l: L("Con patrón", "With skipper") }, { v: "without", l: L("Sin patrón", "Bareboat") }, { v: "both", l: L("Ambas", "Both") }] },
        { k: "price_day", t: "number", l: L("Precio por día (€)", "Price per day (€)"), req: true },
        { k: "cancellation", t: "radio", l: L("Política de cancelación", "Cancellation policy"), opts: [
          { v: "flexible", l: L("Flexible (48 h)", "Flexible") }, { v: "moderate", l: L("Moderada (7 días)", "Moderate") }, { v: "strict", l: L("Estricta", "Strict") }] },
        { k: "deposit", t: "number", l: L("Fianza (€)", "Deposit (€)") },
        { k: "doc_rc_insurance", t: "doc", l: L("Seguro RC para alquiler a terceros (obligatorio)", "Third-party rental liability insurance (required)"), req: true },
      ]},
    ],
  },
};

export const STATUS_LABEL = {
  none: L("No activada", "Not activated"),
  draft: L("Borrador", "Draft"),
  pending_review: L("En revisión", "Under review"),
  active: L("Activa", "Active"),
  rejected: L("Rechazada", "Rejected"),
};

export function visible(cond, data) {
  if (!cond) return true;
  return Object.entries(cond).every(([k, v]) => {
    const d = data[k];
    if (Array.isArray(d)) return d.includes(v);
    return d === v;
  });
}
